<template>
    <div class="scoreboard flex justify-between">
        <div class="scoreboard__gold">            
            <div class="scoreboard__icon scoreboard__icon--gold"></div>
            {{ $store.state.gold }}
        </div>
        <div class="scoreboard__wood">
            <div class="scoreboard__icon scoreboard__icon--wood"></div>
            {{ $store.state.wood }}
        </div>
        <div class="scoreboard__units">
            <div class="scoreboard__icon scoreboard__icon--food"></div>
            {{ $store.getters["workerCount"] }} / {{ $store.getters["supplyCap"] }}
        </div>
    </div>
</template>

<script>
    export default {
        name: "ScoreBoard"
    }
</script>

<style lang="scss" scoped>
    .scoreboard {

        > div {
            @apply flex items-center font-bold;
            min-width: 6rem;
        }

        &__icon {
            width: 14px;
            height: 14px;
            margin-right: 5px;

            &--gold {
                background: url('../assets/images/gold_icon.png');
            }

            &--wood {
                background: url('../assets/images/wood_icon.png');
            }

            &--food {
                background: url('../assets/images/food_icon.png');
            }

            &--peon {
                width: 51px;
                height: 41px;
                background: url('../assets/images/PeonSprite.png') top center;
                animation: play_peon 1s steps(5) infinite;
            }
        }
    }

    @keyframes play_peon {
        100% {
            background-position: 0 -205px;
        }
    }
</style>